import { useEffect } from "react";
import { Alert, Spin,Skeleton,Row,Col,Result } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import {
    fetchSessionData,
    checkOutSession
  } from "./../services";
const antIcon = (
    <LoadingOutlined

      style={{fontSize: 80, top:'30%'}}
      spin
    />
  );
const PaymentRedirect = () => {
    useEffect(() => {
        const fetchPaymentMethod = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const sessionId = urlParams.get("session_id");

            if (sessionId) {
                try {
                    const {status,data} = await fetchSessionData({sessionId});
                   
                    console.log(status,data)

                    const customReq = data.metadata;
                     customReq.paymentMethodId = data.paymentMethodId;
                     customReq.customer_id = data.customer;
                    const subResponse = await checkOutSession(customReq);

                    if (subResponse.status === "success") {
                      const { url } = subResponse.data;
              
                      window.location.href = url;
                    }
                   
                    // if (data.payment_method_id) {
                    //     window.location.href = `/api/create-payment-session?payment_method_id=${data.payment_method_id}`;
                    // }
                } catch (error) {
                    console.error("Error fetching payment method:", error);
                }
            }
        };

        fetchPaymentMethod();
    }, []);

    return (
       <div className="text-center"> 

<Result
    icon={antIcon}
    title="Please wait, the page is redirecting..."
    
  />
       
     </div>
    );
};

export default PaymentRedirect;
